





































import { Component, Vue, Prop } from "vue-property-decorator";
import { UploadFile, VoiceToText } from "@/request/common";

@Component({})
export default class VoiceToTextDialog extends Vue {
  @Prop()
  private visible: boolean | undefined;

  private isRecording: boolean = false;
  private isProcessing: boolean = false;
  private textContent: string = "";
  private mediaRecorder: any = null;
  private recordingStream: any = null;
  private recordedChunks: Blob[] = [];
  private recordingTime: number = 0;
  private recordingTimer: any = null;

  private get ifVisible() {
    return this.visible ? this.visible : false;
  }

  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }

  /**
   * @description 开始录音
   */
  private startRecording() {
    this.textContent = "";
    this.recordedChunks = [];
    this.recordingTime = 0;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        this.recordingStream = stream;
        this.mediaRecorder = new MediaRecorder(stream);

        this.mediaRecorder.ondataavailable = (e: any) => {
          if (e.data && e.data.size > 0) {
            this.recordedChunks.push(e.data);
          }
        };

        this.mediaRecorder.onstop = () => {
          if (this.recordingStream) {
            this.recordingStream.getTracks().forEach((track: any) => track.stop());
            this.recordingStream = null;
          }
          this.processRecording();
        };

        this.mediaRecorder.start();
        this.isRecording = true;
        this.startTimer();
      })
      .catch((err) => {
        console.error("Error accessing media devices:", err);
        this.$message({
          type: "error",
          message: "无法访问麦克风，请检查权限设置",
        });
      });
  }

  /**
   * @description 停止录音
   */
  private stopRecording() {
    if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
      this.mediaRecorder.stop();
      this.isRecording = false;
      this.stopTimer();
    }
  }

  /**
   * @description 开始计时
   */
  private startTimer() {
    this.recordingTimer = setInterval(() => {
      this.recordingTime++;
    }, 1000);
  }

  /**
   * @description 停止计时
   */
  private stopTimer() {
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
      this.recordingTimer = null;
    }
  }

  /**
   * @description 格式化时间
   */
  private formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  /**
   * @description 处理录音数据
   */
  private async processRecording() {
    if (this.recordedChunks.length === 0) {
      this.$message({
        type: "warning",
        message: "录音数据为空",
      });
      return;
    }

    this.isProcessing = true;
    const loading = this.$loading({
      lock: true,
      text: "正在处理录音...",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });

    try {
      // 创建音频 Blob
      const blob = new Blob(this.recordedChunks, { type: "audio/webm" });

      // 上传文件
      const form = new FormData();
      form.append("type", "file");
      form.append("file", blob, `recording_${Date.now()}.webm`);

      const uploadResult: any = await UploadFile(this, form, loading);

      if (!uploadResult || !uploadResult.full_file_url) {
        throw new Error("上传失败，未获取到文件URL");
      }

      // 调用语音转文字接口
      const loading2 = this.$loading({
        lock: true,
        text: "正在处理录音...",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      console.log('准备调用 VoiceToText，参数：', { speech_url: uploadResult.full_file_url });
      const speechResult: any = await VoiceToText(
        this,
        { speech_url: uploadResult.full_file_url },
        loading2 // 语音转文字的loading
      );
      loading2 && loading2.close();
      console.log('speechResult', speechResult);

      // 处理返回格式：可能是 { result: { text: "..." } } 或直接是 { audio_info: {...}, result: {...} }
      let text = "";
      if (speechResult) {
        // 如果 speechResult 本身就是包含 result 的对象
        if (speechResult.result && speechResult.result.text) {
          text = speechResult.result.text;
        }
      }

      if (text) {
        this.textContent = text;
        this.$message({
          type: "success",
          message: "转换成功",
        });
      } else {
        console.warn("无法提取文字内容，响应数据：", speechResult);
        throw new Error("转换失败，未获取到文字内容");
      }
    } catch (err: any) {
      console.error("处理录音失败:", err);
      // 处理不同类型的错误：可能是 Error 对象、字符串、或其他类型
      let errorMessage = "处理录音失败，请重试";
      this.$message({
        type: "error",
        message: errorMessage,
      });
    } finally {
      loading.close();
      this.isProcessing = false;
    }
  }

  /**
   * @description 关闭对话框
   */
  private closeDialog() {
    if (this.isRecording) {
      this.stopRecording();
    }
    if (this.recordingStream) {
      this.recordingStream.getTracks().forEach((track: any) => track.stop());
      this.recordingStream = null;
    }
    this.stopTimer();
    this.textContent = "";
    this.isRecording = false;
    this.isProcessing = false;
    this.recordedChunks = [];
    this.recordingTime = 0;
    this.ifVisible = false;
  }

  /**
   * @description 确认
   */
  private confirm() {
    this.$emit("confirm", this.textContent);
    this.closeDialog();
  }
}
